import * as yup from 'yup';

export const getConfirmationBisSchema = yup.object().shape({
  domain: yup.string().required('Ce champs est requis'),
  fieldOfActivity: yup.string().required('Ce champs est requis'),
});
